import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/base.less"
import 'element-ui/lib/theme-chalk/index.css';
import { Carousel, CarouselItem,Icon,Menu,Submenu,MenuItem,Button,Input,Select,Option,Card,Table,TableColumn,Message,MessageBox,Notification,Loading } from 'element-ui';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import Http from './assets/js/http.js';
import Common from './assets/js/common.js'
Vue.use(Http)
// Vue.use(Common)
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载，通过全局方法 Vue.use() 使用插件
const i18n = new VueI18n({
  locale: localStorage.getItem('lang')||'en', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh': require('./assets/language/zh'),  //
    'en': require('./assets/language/en')
  }
})

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.use(Carousel).use(CarouselItem).use(Icon).use(Menu).use(Submenu).use(MenuItem).use(Button)
.use(Input).use(Select).use(Option).use(Card).use(Table).use(TableColumn).use(Loading.directive);
Vue.prototype.$notify = Notification;
Vue.prototype.$loading = Loading.service;
// Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$message = Message;
Vue.config.productionTip = false
Vue.prototype.$window = window
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
